import { Button, Col, Descriptions, Divider, Icons, message, PageHeader, Row, Spin, Switch, Tag, Typography } from '@pankod/refine-antd'
import { useNavigation, useOne, useUpdate, useShow, useList, useUpdateMany } from '@pankod/refine-core'
import PopupModal from 'components/PopupModal'
import { useUserContext } from 'context/user'
import dayjs from 'dayjs'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Permissions from 'permissions'

const { LeftOutlined, ClockCircleOutlined, CheckOutlined } = Icons

type Permission = {
  granted?: boolean
}

export const ShowTask = () => {
  const { userRole } = useUserContext()
  const { goBack, push } = useNavigation()
  const pathname = window.location.pathname
  const splitStr = pathname?.split('/')
  const task_id = splitStr?.slice(3)?.[0]
  // const { params2 } = useParams()
  const { mutateAsync: update } = useUpdate()
  const { mutateAsync: updateMany } = useUpdateMany()
  const [open, setOpen] = useState<boolean>(false)
  const [readPermission, setReadPermission] = useState<Permission>({})
  console.log('params', pathname, splitStr, task_id)
  // const { queryResult } = useShow({
  //   resource: 'support_tasks',
  //   metaData: {
  //     fields: [
  //       'id',
  //       'uid',
  //       'active',
  //       'name',
  //       'assignee_id',
  //       { assignee_user_details: ['displayName'] },
  //       'created_by',
  //       { created_by_user_details: ['displayName'] },
  //       'start_date',
  //       'end_date',
  //       'status',
  //       'module_id',
  //       { module: ['id', 'label'] },
  //       {
  //         permissions: ['id', 'active', 'can_create', 'can_read', 'can_update', 'can_delete'],
  //       },
  //     ],
  //   },
  // })
  // const { data: support_tasks } = queryResult
  // console.log('support_tasks', support_tasks?.data)
  // task by pk
  const { isLoading, data } = useOne({
    resource: 'support_tasks',
    id: task_id,
    metaData: {
      fields: [
        'id',
        'uid',
        'active',
        'name',
        'assignee_id',
        'description',
        { assignee_user_details: ['displayName'] },
        'created_by',
        { created_by_user_details: ['displayName'] },
        'start_date',
        'end_date',
        'status',
        'module_id',
        { module: ['id', 'label'] },
        {
          permissions: ['id', 'active', 'can_create', 'can_read', 'can_update', 'can_delete', 'module_id', { module: ['id', 'label'] }],
        },
      ],
    },
  })
  const task = data?.data
  const access = task?.permissions?.[0]
  // console.log(task, 'params_')
  const start = dayjs(task?.start_date)
  const end = dayjs(task?.end_date)
  const days = end.diff(start, 'days')
  const modules = task?.permissions
  // const modules = permissiondata?.data
  // const module_permissions = task?.permissions
  console.log('modules', modules)

  // get all inactive permission by task_id
  const { data: permissiondata } = useList({
    resource: 'permissions',
    metaData: {
      fields: ['id', 'task_id', 'active', { module: ['id', 'label'] }],
    },
    config: {
      filters: [
        {
          field: 'task_id',
          operator: 'eq',
          value: task_id,
        },
        {
          field: 'active',
          operator: 'eq',
          value: false,
        },
      ],
    },
    queryOptions: {
      enabled: !!task_id,
    },
  })
  const permission_ids: any = permissiondata?.data
  // console.log('module_permissions', permission_ids)
  // console.log('permission_ids', permission_ids)
  const handleConfirm = async () => {
    if (task?.status === 'Assigned') {
      await Promise.all([
        updateMany({
          resource: 'permissions',
          ids: permission_ids?.map((p: any) => p?.id),
          values: {
            active: true,
          },
          successNotification: false,
        }),
        update(
          {
            resource: 'support_tasks',
            id: task_id,
            values: {
              status: 'In Progress',
            },
            successNotification: false,
          },
          {
            onSuccess: data => {
              setOpen(false)
              message.open({
                type: 'success',
                content: 'Task Accepted',
              })
            },
          }
        ),
      ])
    } else if (task?.status === 'In Progress') {
      await Promise.all([
        updateMany({
          resource: 'permissions',
          ids: modules?.filter((mod: any) => mod?.active === true)?.map((p: any) => p?.id),
          values: {
            active: false,
          },
          successNotification: false,
        }),
        update(
          {
            resource: 'support_tasks',
            id: task_id,
            values: {
              status: 'Completed',
            },
            successNotification: false,
          },
          {
            onSuccess: data => {
              setOpen(false)
              message.open({
                type: 'success',
                content: 'Task Completed',
              })
            },
          }
        ),
      ])
    }
  }

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    // console.log(readPermission, 'readpermission')
  }, [readPermission])
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('tasks'))
      // setCreatePermission(Permissions.can(userRole).createAny('support_tasks'))
      // setEditPermission(Permissions.can(userRole).updateAny('support_tasks'))
      // setDeletePermission(Permissions.can(userRole).deleteAny('support_tasks'))
    }
  }, [userRole])

  // if (isLoading) {
  //   return <Spin />
  // }
  return (
    <PageHeader
      className="site-page-header-responsive"
      ghost={false}
      title={`#${task?.uid} - ${task?.name}`}
      // title={`#`}
      extra={[
        <Button key="close" onClick={() => goBack()} icon={<LeftOutlined />}>
          Back
        </Button>,
        <>
          <Button
            type="primary"
            // fire hasura event when task completed
            disabled={task?.status === 'Completed' || task?.status === 'Expired'}
            icon={task?.status === 'Assigned' ? <ClockCircleOutlined spin /> : task?.status === 'In Progress' ? <CheckOutlined /> : null}
            onClick={() => setOpen(true)}
          >
            {task?.status === 'Assigned'
              ? 'Accept'
              : task?.status === 'In Progress' || task?.status === 'Expired'
              ? 'Mark as Completed'
              : task?.status === 'Completed'
              ? 'Completed'
              : ''}
          </Button>
          <PopupModal
            visible={open}
            close={() => {
              setOpen(false)
            }}
            title={
              task?.status === 'Assigned' ? 'Do you want to accept this task' : task?.status === 'In Progress' ? 'Have you completed this task ?' : ''
            }
            confirm={handleConfirm}
          />
        </>,
      ]}
    >
      <Row
        gutter={16}
        style={{
          marginBottom: '1rem',
        }}
      >
        <Col lg={24} xs={24}>
          <Tag
            color={
              task?.status === 'Assigned' ? 'cyan' : task?.status === 'Completed' ? 'green' : task?.status === 'In Progress' ? 'blue' : undefined
            }
          >
            {task?.status}
          </Tag>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Assignee:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {task?.assignee_user_details?.displayName}
          </p>
        </Col>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Assigned by:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {task?.created_by_user_details?.displayName}
          </p>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Start Date:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {task?.start_date}
          </p>
        </Col>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            End Date:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {task?.end_date}
          </p>
        </Col>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            No of Days:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {days}
          </p>
        </Col>
      </Row>
      <Row>
        <Col lg={24} xs={24}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Task Description:
          </h4>
          <p
            style={{
              textTransform: 'capitalize',
            }}
          >
            {task?.description}
          </p>
        </Col>
      </Row>
      <Divider style={{ margin: '12px 0' }} />
      <Row gutter={16}>
        <Col xs={24} lg={6}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Module Assigned:
          </h4>
          {modules?.map((module: any) => (
            <Tag
              style={{
                marginBottom: '8px',
              }}
            >
              {module?.module?.label}
            </Tag>
          ))}
        </Col>
        <Col lg={18} xs={24}>
          <h4
            style={{
              fontWeight: 'bold',
              marginBottom: '2px',
            }}
          >
            Module Permissions:
          </h4>
          <Row>
            {modules?.map((module: any) => (
              <Col
                lg={4}
                style={{
                  marginBottom: '8px',
                }}
              >
                <h5
                  style={{
                    marginBottom: '8px',
                  }}
                >
                  {module?.module?.label}
                </h5>
                {module?.can_create && <Tag color="green">Create</Tag>}
                {module?.can_read && <Tag color="green">View</Tag>}
                {module?.can_update && <Tag color="green">Edit</Tag>}
                {module?.can_delete && <Tag color="green">Delete</Tag>}
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </PageHeader>
  )
}
